<!-- crud asignar url de la api URL="url de la api" titulo="un titulo para la pestaña de la pagina" [dato]="variable que contiene el formulario]-->
<app-listar #ctrl URL="pago" titulo="Pagos"></app-listar>

<!-- Menu principal "-->
<app-sistema-menu></app-sistema-menu>

<div class="contenedor columns " style="height:100%; ">
    <div class="column is-2 is-hidden-mobile menu-izquierda">

        <!-- Menu izquierda del modulo enviroment" -->
        <app-sistema-menu-aside></app-sistema-menu-aside>
    </div>
    <div class="column" style="padding:0px;">
        <div style="background: #FFF; border-radius: 1em; ">

            <!-- Opciones y busqueda -->
            <app-tabla-opciones [ctrl]="ctrl"></app-tabla-opciones>

            <div id="exportar_datos" style="overflow-y:auto; overflow-x: hidden; display:block; height: 78.4vh;" >

                <!--Tabla -->
                <table class="table is-striped  is-fullwidth" *ngIf="ctrl.tipo_grid && !ctrl.cargando">
                    <thead>
                        <tr>
                            <th>Folio </th>
                            <th>Fecha</th>
                            <th>Cliente </th>
                            <th>Importe</th>
                            <th>Capturo</th>
                            <th>Comentario</th>
                            <th width="1%" class="no_pdf">Opciones</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let item of ctrl.dato; let i=index">
                            <td style="vertical-align: middle;">{{item.movimientos.folio}} </td>
                            <td style="vertical-align: middle;">{{ item.movimientos.created_at }} </td>
                            <th style="vertical-align: middle;">
                                <span *ngIf="item.movimientos.personas">{{item.movimientos.personas.nombre}} {{item.movimientos.personas.apellido_paterno}} {{item.movimientos.personas.apellido_materno}}</span>
                            </th>
                            <td style="vertical-align: middle;">
                                {{item.movimientos.total | currency:ctrl.configuracion.sucursal.moneda:'symbol-narrow'}}
                                <span style="color:red" *ngIf="item.movimientos.total_devolucion > 0">Dev: {{item.movimientos.total_devolucion | currency:ctrl.configuracion.sucursal.moneda:'symbol-narrow' }}</span>
                                <span style="color:green" *ngIf="item.movimientos.total_devolucion > 0">Total: {{item.movimientos.total - item.movimientos.total_devolucion | currency:ctrl.configuracion.sucursal.moneda:'symbol-narrow' }}</span>
                            </td>
                            <td style="vertical-align: middle;">{{ item.movimientos.usuarios.nombre }} </td>
                            <td style="vertical-align: middle;">{{ item.movimientos.comentarios }} </td>
                            <td style="vertical-align: middle;" class="has-text-centered no_pdf">
                                <!-- acciones -->
                                <a (click)="calcular_importe_articulo(item, ctrl.json)" id="funcion_secundaria{{i}}"></a>
                                <app-tabla-acciones [item]="item" [index]="i" [ctrl]="ctrl" class="level-left"></app-tabla-acciones>
                            </td>

                        </tr>
                        <tr *ngIf="ctrl.dato.length == 0">
                            <td colspan="5" style="vertical-align: middle; color:#888;">Esta lista está vacía.</td>
                        </tr>
                    </tbody>

                </table>

                <!--Lista -->
                <span *ngIf="!ctrl.tipo_grid && !ctrl.cargando" class="lista_lista">
                    <div class="box" *ngFor="let item of ctrl.dato; let i=index" style="margin-bottom:0.1rem;" [style.background]="i%2 == 0 ? '#fafafa' : '#ffffff'">
                        <article class="media">
                            <div class="media-left">
                                <figure class="image is-64x64">
                                    <img src="./assets/128x128.png" alt="Image">
                                </figure>
                            </div>
                            <div class="media-content">
                                <div class="content">
                                    <p>

                                        <strong class="tag is-info is-medium" style="font-size:12pt">Folio: {{item.movimientos.folio}}</strong>
                                        <strong class="tag is-dark is-medium" style="font-size:12pt">Codigo: {{item.movimientos.codigo}}</strong>
                                        <strong class="tag is-dark is-medium">Fecha de entrega: {{item.movimientos.created_at}}</strong>
                                        <strong class="tag is-primary is-medium" style="font-size:12pt">Cliente:
                                            <span *ngIf="item.movimientos.personas">{{item.movimientos.personas.nombre}} {{item.movimientos.personas.apellido_paterno}} {{item.movimientos.personas.apellido_materno}}</span>
                                        </strong>
                                        <strong class="tag is-medium">
                                            Importe: {{item.movimientos.total | currency:ctrl.configuracion.sucursal.moneda:'symbol-narrow'}}
                                            <span style="color:red" *ngIf="item.movimientos.total_devolucion > 0">Dev: {{item.movimientos.total_devolucion | currency:ctrl.configuracion.sucursal.moneda:'symbol-narrow' }}</span>
                                            <span style="color:green" *ngIf="item.movimientos.total_devolucion > 0">Total: {{item.movimientos.total - item.movimientos.total_devolucion | currency:ctrl.configuracion.sucursal.moneda:'symbol-narrow' }}</span>
                                        </strong>

                                        <strong class="tag is-default is-medium">Capturo: {{item.movimientos.usuarios.nombre}}</strong>
                                        <strong class="tag is-default is-medium">Comentario: {{item.movimientos.comentarios}}</strong>
                                        <a (click)="calcular_importe_articulo(item, ctrl.json)" id="funcion_secundaria{{i}}"></a>
                                    </p>
                                </div>
                                <nav class="level is-mobile" style="float:right">
                                    <div class="level-left">

                                        <!-- acciones -->
                                        <app-tabla-acciones [item]="item" [index]="i" [ctrl]="ctrl" class="level-left"></app-tabla-acciones>
                                    </div>
                                </nav>
                            </div>
                        </article>
                    </div>
                </span>
              </div>
            <!-- Paginación para la lista  -->
            <app-paginacion [ctrl]="ctrl"></app-paginacion>
        </div>

    </div>
</div>

<div style="display:none" id="imprimir">
    <div dir="ltr" *ngIf="ctrl.json">
        <p align="center" style="margin-bottom:0cm;line-height:100%">
            <br>
        </p>
        <p align="center" style="margin-bottom:0cm;line-height:100%">
            <br>
        </p>
        <p align="center">
            <font >
                {{ctrl.configuracion.empresa.nombre}}</font>
        </p>
        <p align="center">
            <font >
                {{ctrl.configuracion.empresa.direccion}}
            </font>
        </p>
        <p align="center" style="font-weight:normal">
            <br>
        </p>
        <hr style="border:2px dashed black;width:100%">
        <p align="center" style="font-style:normal;font-weight:normal">
            <font >{{ctrl.configuracion.sucursal.nombre}}
            </font>
        </p>
        <p align="center" style="font-style:normal;font-weight:normal">
            <font >{{ctrl.configuracion.sucursal.direccion}}</font>
        </p>
        <p align="center" style="font-style:normal;font-weight:normal">
            <font >Tel: {{ctrl.configuracion.sucursal.telefono}} Correo: {{ctrl.configuracion.sucursal.correo}}</font>
        </p>
        <hr style="border:2px dashed black;width:100%">
        <p align="left"> </p>


        <p align="right">
            <font >
                <span style="font-weight:normal">CODIGO : {{ctrl.json.movimientos.codigo}}</span>
                <b> </b>
            </font>
        </p>

        <p align="right" style="font-weight:normal">
            <font >
                <span style="font-weight:normal">FECHA : </span>
                <b>{{ctrl.json.movimientos.created_at | formatoFecha}} </b>
            </font>
        </p>

        <p align="right" style="font-weight:normal" *ngIf="ctrl.json.movimientos.personas">
            <font >
                <span style="font-weight:normal">CLIENTE : </span>
                <b>{{ctrl.json.movimientos.personas.nombre}} {{ctrl.json.movimientos.personas.apellido_paterno}} {{ctrl.json.movimientos.personas.apellido_materno}} </b>
            </font>
        </p>

        <hr style="border:2px dashed black;width:100%">
        <p align="center" style="margin-bottom:0cm;line-height:100%">
            <br>
        </p>
        <p align="center" style="margin-bottom:0cm;line-height:100%">
            <font >
                <b>Pago de inscripción</b>
            </font>
        </p>

        <p align="left">
            <br>
        </p>
        <table width="100%" cellpadding="4" cellspacing="0" class="table is-striped  is-fullwidth">
            <tr valign="top">
                <td width="15%" style="border:none;padding:0cm">
                    <p>
                        <font >
                            <i>
                                <b>CANT.</b>
                            </i>
                        </font>
                    </p>
                </td>
                <td width="40%" style="border:none;padding:0cm">
                    <p>
                        <font >
                            <i>
                                <b>ARTICULO</b>
                            </i>
                        </font>
                    </p>
                </td>
                <td width="20%" style="border:none;padding:0cm">
                    <p>
                        <font >
                            <i>
                                <b>PRECIO</b>
                            </i>
                        </font>
                    </p>
                </td>
                <td width="20%" style="border:none;padding:0cm">
                    <p>
                        <font >
                            <i>
                                <b>DESCUENTO</b>
                            </i>
                        </font>
                    </p>
                </td>
                <td width="25%" style="border:none;padding:0cm">
                    <p>
                        <font >
                            <i>
                                <b>IMPORTE</b>
                            </i>
                        </font>
                    </p>
                </td>
            </tr>
            <tr *ngFor="let item of ctrl.json.movimientos.movimientos_articulos">
                <td>{{item.cantidad}}</td>
                <td>{{item.articulos.nombre}}</td>
                <td>{{item.precio_unitario}}</td>
                <td>{{item.descuento}}%</td>
                <td>{{item.precio_con_descuentos | currency:ctrl.configuracion.sucursal.moneda:'symbol-narrow'}}</td>
            </tr>
        </table>
        <div *ngIf="ctrl.json.movimientos.devoluciones.length > 0">
            <p align="center" style="margin-bottom:0cm;line-height:100%">
                <font>
                    <b>DEVOLUCIÓN</b>
                </font>
            </p>

            <p align="left">
                <br>
            </p>
            <div *ngFor="let dev of ctrl.json.movimientos.devoluciones">
                <table width="100%" cellpadding="4" cellspacing="0" class="table is-striped  is-fullwidth">
                    <tr valign="top">
                        <td width="15%" style="border:none;padding:0cm">
                            <p>
                                <font>
                                    <i>
                                        <b>CANT.</b>
                                    </i>
                                </font>
                            </p>
                        </td>
                        <td width="40%" style="border:none;padding:0cm">
                            <p>
                                <font>
                                    <i>
                                        <b>ARTICULO</b>
                                    </i>
                                </font>
                            </p>
                        </td>
                        <td width="20%" style="border:none;padding:0cm">
                            <p>
                                <font>
                                    <i>
                                        <b>PRECIO</b>
                                    </i>
                                </font>
                            </p>
                        </td>
                        <td width="20%" style="border:none;padding:0cm">
                            <p>
                                <font>
                                    <i>
                                        <b>DESCUENTO</b>
                                    </i>
                                </font>
                            </p>
                        </td>
                        <td width="25%" style="border:none;padding:0cm">
                            <p>
                                <font>
                                    <i>
                                        <b>IMPORTE</b>
                                    </i>
                                </font>
                            </p>
                        </td>
                    </tr>
                    <tr *ngFor="let item of dev.movimientos.movimientos_articulos">
                        <td>{{item.cantidad}}</td>
                        <td>{{item.articulos.nombre}}</td>
                        <td>{{item.precio_unitario}}</td>
                        <td>{{item.descuento}}%</td>
                        <td>{{item.precio_con_descuentos | currency:ctrl.configuracion.sucursal.moneda:'symbol-narrow'}}</td>
                    </tr>
                </table>
            </div>
        </div>
        <p align="center" style="margin-bottom:0cm;line-height:100%">
            <br>
        </p>

        <div>
            <p align="right" style="font-weight:normal">
                <strong>
                    <font>SUBTOTAL</font>

                </strong>
                <font>
                    {{ctrl.json.movimientos.subtotal | currency:ctrl.configuracion.sucursal.moneda:'symbol-narrow'}}
                </font>
            </p>
        </div>
        <div *ngIf="ctrl.json.movimientos.descuento > 0">
            <p align="right" style="font-weight:normal">
                <strong>
                    <font>Descuento</font>

                </strong>
                <font>
                    {{ctrl.json.movimientos.descuento | currency:ctrl.configuracion.sucursal.moneda:'symbol-narrow'}}
                </font>
            </p>
        </div>
        <div>
            <p align="right" style="font-weight:normal">
                <strong>
                    <font >TOTAL</font>

                </strong>
                <font >
                    {{ctrl.json.movimientos.total | currency:ctrl.configuracion.sucursal.moneda:'symbol-narrow'}}
                </font>
            </p>
        </div>
        <div *ngFor="let moneda of ctrl.configuracion.sucursal.conversiones_monedas">
            <p align="right" style="font-weight:normal">
                <strong>
                    <font >{{moneda.nombre}}</font>

                </strong>
                <font >
                    {{(ctrl.json.movimientos.total / moneda.tipo_cambio) | currency:ctrl.configuracion.sucursal.moneda:'symbol-narrow'}}
                </font>
            </p>
        </div>
        <div *ngFor="let p of ctrl.json.movimientos.pagos">
            <p align="right" style="font-weight:normal">
                <strong>
                    {{p.tipos_formas_pagos.nombre }}
                </strong>
                <font>
                    {{p.importe | currency:ctrl.configuracion.sucursal.moneda:'symbol-narrow'}}
                </font>
            </p>
            <p align="right" style="font-weight:normal">
                <font>
                    {{p.tipos_metodos_pagos.nombre }}
                </font>
            </p>
            <hr style="border:1px dashed black;width:100%">
        </div>
        <div *ngIf="ctrl.json.movimientos.cambio">
            <p align="right" style="font-weight:normal">
                <strong>
                    <font >CAMBIO</font>

                </strong>
                <font >
                    {{ctrl.json.movimientos.cambio | currency:ctrl.configuracion.sucursal.moneda:'symbol-narrow'}}
                </font>
            </p>
            <div *ngFor="let moneda of ctrl.configuracion.sucursal.conversiones_monedas">
                <p align="right" style="font-weight:normal">
                    <strong>
                        <font >{{moneda.nombre}}</font>

                    </strong>
                    <font >
                        {{(ctrl.json.movimientos.cambio / moneda.tipo_cambio) | currency:ctrl.configuracion.sucursal.moneda:'symbol-narrow'}}
                    </font>
                </p>
            </div>
        </div>

        <p align="center" style="margin-bottom:0cm;line-height:100%">
            <br>
        </p>
        <p align="left">
            <font>
                <span style="font-weight:normal">
                    ATENDIÓ :
                </span>
                <span style="font-weight:normal">
                    {{ctrl.json.movimientos.usuarios.nombre}}
                </span>
            </font>
        </p>
        <p align="center" style="font-weight:normal">
            <font>
                Gracias por su compra
            </font>
        </p>
        <p align="center">
            <img [src]="'data:image/png;base64,' + ctrl.json.movimientos.barcode">
        </p>
    </div>
</div>
